import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Provider from '../../redux/Provider';
import { toggleCart } from '../../redux/actions';

const mapStateToProps = ({ cart }) => ({ cart });
const mapDispatchToProps = (dispatch) => bindActionCreators({ toggleCart }, dispatch);

const basketSize = (cart) => cart.item_count > 9 ? "9+" : cart.item_count;

const CartAction = ({ cart, toggleCart }) => {
  if (!cart || cart.item_count === 0) { return null; }

  return (
    <div className="cart-action">
      <a onClick={toggleCart} className="cart-action__link">
        <span>{basketSize(cart)}</span>
      </a>
    </div>
  );
}

export default Provider(
  connect(mapStateToProps, mapDispatchToProps)(CartAction)
);



// WEBPACK FOOTER //
// ./assets/scripts/components/Cart/CartAction.js